module.exports = {
  "country": "UK",
  "artist": "Cliff Richard",
  "song": "Congratulations",
  "year": "1968",
  "place": "2",
  "spotify": "1ZfbMOw5VSh5Qqr8hgLCkJ"
};